var _style, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWallet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "animated",
    id: "freepik_stories-wallet",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlnsSvgjs: "http://svgjs.com/svgjs",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "svg#freepik_stories-wallet:not(.animated) .animable {opacity: 0;}svg#freepik_stories-wallet.animated #freepik--background-simple--inject-34 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) lightSpeedRight;animation-delay: 0s;}svg#freepik_stories-wallet.animated #freepik--Wallet--inject-34 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) fadeIn;animation-delay: 0s;}svg#freepik_stories-wallet.animated #freepik--Card--inject-34 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) zoomIn;animation-delay: 0s;}            @keyframes lightSpeedRight {              from {                transform: translate3d(50%, 0, 0) skewX(-20deg);                opacity: 0;              }              60% {                transform: skewX(10deg);                opacity: 1;              }              80% {                transform: skewX(-2deg);              }              to {                opacity: 1;                transform: translate3d(0, 0, 0);              }            }                    @keyframes fadeIn {                0% {                    opacity: 0;                }                100% {                    opacity: 1;                }            }                    @keyframes zoomIn {                0% {                    opacity: 0;                    transform: scale(0.5);                }                100% {                    opacity: 1;                    transform: scale(1);                }            }        ")), /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-simple--inject-34",
    className: "animable",
    style: {
      transformOrigin: "242.371px 225.195px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M325.67,40.09c-36.81.63-65.19,30.73-96.7,49.77-47.58,28.75-108.69,34.59-148.88,73C52.58,189.19,39,228.83,42.84,266.7s24.64,73.37,54.72,96.71c19.18,14.87,41.69,24.9,64.66,32.75,23.28,7.94,47.52,13.83,72.12,14.14,34.09.43,67.58-9.88,98.42-24.43,21.45-10.11,42.13-22.47,59-39.14,15.94-15.74,28.16-35.08,36.53-55.86,20.69-51.36,17.4-110.23-.54-162.62C412.91,84.92,376.63,39.21,325.67,40.09Z",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "242.371px 225.195px"
    },
    id: "elw9fo219hneg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "els6eguzpxmqo"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M325.67,40.09c-36.81.63-65.19,30.73-96.7,49.77-47.58,28.75-108.69,34.59-148.88,73C52.58,189.19,39,228.83,42.84,266.7s24.64,73.37,54.72,96.71c19.18,14.87,41.69,24.9,64.66,32.75,23.28,7.94,47.52,13.83,72.12,14.14,34.09.43,67.58-9.88,98.42-24.43,21.45-10.11,42.13-22.47,59-39.14,15.94-15.74,28.16-35.08,36.53-55.86,20.69-51.36,17.4-110.23-.54-162.62C412.91,84.92,376.63,39.21,325.67,40.09Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.7,
      transformOrigin: "242.371px 225.195px"
    },
    className: "animable"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Wallet--inject-34",
    className: "animable",
    style: {
      transformOrigin: "205.621px 305.28px"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "elq8r0vxz42lm"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M348.49,252.05c-.26-7.53-.75-15.56-1.56-23.87-1.09-16.6-3.17-32.1-6.94-41.85h0C319.23,182.08,211.38,190,211.3,190l-.67-3-.27-1.19-.48-2.09-.13-.48c-.7-2.82-1.49-5.61-2.41-8.38h0s-81.76-7.3-108.88-.22h0c0,.24,0,.47,0,.71l.08,6.69c.08,12.95-.22,25.1.45,38.44v.1h0a2.17,2.17,0,0,0-.39,0,5.75,5.75,0,0,0-4.67,3.79h0a5.73,5.73,0,0,0-.29,2.42L94,231c0,.07,0,.13,0,.2,1,10.62,2,21.14,2,21.14h0s.52.05,1.37.09l4.49.32c-9.56.88-20,13.5-19.54,24.35s-10,31.28-7.39,43c2,9.16,12.29,23.89,17.3,35.08l-.39,2.22L69.47,402.32c1.5-2.2,15,56.5,77.7,44.07l44.61-72.68h0a86.06,86.06,0,0,0,13.58-12.77,22.21,22.21,0,0,0,4.21-5.82h0a31.1,31.1,0,0,0,3.61-8.2c.2-.76.41-1.51.63-2.28,3.64-9.27,8.5-21.92,12.06-30.68,47-1.4,96.35-4.27,121.13-10.1h.05C349.45,287.56,349.5,269.27,348.49,252.05ZM107.12,293.12a72.18,72.18,0,0,1-.7-8.17c.55,2.88,1.15,5.75,1.78,8.63C107.84,293.42,107.48,293.26,107.12,293.12Z",
    style: {
      opacity: 0.1,
      transformOrigin: "209.291px 309.835px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M64.36,399.45s20.08,59.37,82.81,46.94c0,0,13.92-65.35,25.58-75,7.52-6.2,24.13-17.32,27.68-25.37s17.81-46.28,20.57-50.88-29.92-57.53-29.92-57.53l-68.84,35.52-38.3,68S76.59,385.13,64.36,399.45Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "142.763px 342.856px"
    },
    id: "elteap2k2u7ph",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.27,346.43s-4.91,36.71-21.14,55.89",
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "72.7px 374.375px"
    },
    id: "el6k0y9dl1gl3",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.17,446.39s13.84-63.23,25.58-75c0,0,26.52-15.42,31.3-33.57,3.31-12.57,9.33-27.06,12.21-33.64",
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "181.715px 375.285px"
    },
    id: "elr0keof0yp1a",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.75,306.21c-1-.64,16.05,13,16.71,31.64",
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "161.084px 322.019px"
    },
    id: "eln78tyk75sop",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.92,294.78c-55.28,13-233.32,11.29-233.32,11.29-1.5-3.16-3.31-11.12-5.06-20.34-3.5-18.51-6.77-42.1-6.77-42.1l-5.89-.41s-1-10.52-2-21.14,5-10.61,5-10.61l-.43-36.76-.11-9.18c27.12-7.08,108.88.22,108.88.22l2.55,8.86,1.42,6.28,128.68-3.63C342.67,207.77,337.92,294.78,337.92,294.78Z",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "211.816px 234.292px"
    },
    id: "elhwtcd6m2o3k",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el6j1krfurwme"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 225.82,
    y: 208.02,
    width: 96.98,
    height: 29.73,
    rx: 6.29,
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "274.31px 222.885px",
      transform: "rotate(-2.86241deg)"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "323.54 246.54 323.81 249.39 226.63 253.15 226.55 250.59 323.54 246.54",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "275.18px 249.845px"
    },
    id: "elkgegki06dmj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "324.02 256.45 324.11 259.01 226.94 262.6 226.85 260.05 324.02 256.45",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "275.48px 259.525px"
    },
    id: "elov5wp63ap7",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el2bek5j23ffp"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M330.85,177.26s14.34,68,7.07,117.52c0,0-90.68,10.64-121.73,8.92l-1.27-16.55,2.6-.4S205,192.29,202.16,180.89C202.16,180.89,310.15,173,330.85,177.26Z",
    style: {
      opacity: 0.3,
      transformOrigin: "271.068px 239.943px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "el1puljjbqyto"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M211.93,286.91,213,299.42s-91.4,4-99.44,1.09.43-7.55,21.69-9.22S211.93,286.91,211.93,286.91Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.8,
      transformOrigin: "161.784px 294.24px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("ellipse", {
    cx: 157.36,
    cy: 226.29,
    rx: 8.35,
    ry: 7.56,
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "157.36px 226.29px"
    },
    id: "eljp8q15z1wfj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.77,243.62a324,324,0,0,0,11.82,62.45c38.77-.33,77.53-.76,116.29-2s78.59-3.86,117-9.29c0,0,6.88-60.76-7.07-117.52-15.42-3.21-128.26,3.61-128.26,3.61",
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "216.173px 241.235px"
    },
    id: "elxr6hju508bp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.93,286.91,213,299.42l-87,2c-3.59.31-9.18.78-12.48-.91-1.5-.77-2.58-2.65-1.87-4.19.64-1.38,2.32-1.87,3.82-2.17,10.64-2.19,21.5-3.11,32.33-3.91q34.78-2.58,69.67-3.49c-.49,0-6.16-46.79-6.79-51.11-2.46-16.9-4.8-33.87-7.84-50.68a136.57,136.57,0,0,0-4.69-19.21c-35.84-2.56-73.27-4.93-108.89-.22.33,15.87-.26,30,.55,45.94",
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "153.365px 232.278px"
    },
    id: "eli89uahy8gl",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.26,301.36a7.75,7.75,0,0,1-.38-2",
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "103.07px 300.36px"
    },
    id: "elubcwll0nbw",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.46,295.57c1.33-3.33,5.32-7.09,16.17-8.29,19.79-2.2,62.93-6.16,88.24-7.12",
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeDasharray: "3.91096, 3.91096",
      transformOrigin: "155.665px 287.865px"
    },
    id: "eluv3sn7ljy0q",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.83,280.09l2-.07-.27-2",
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "210.83px 279.055px"
    },
    id: "elv99al3z9vf",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211,274.19c-4.55-32.73-9.59-65.22-15.36-97.77",
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeDasharray: "3.88194, 3.88194",
      transformOrigin: "203.32px 225.305px"
    },
    id: "elhih3of6sor9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.32,174.51l-.36-2-2-.14",
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "194.14px 173.44px"
    },
    id: "el7f1yof8h0gu",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.92,172.11c-16.63-1.11-63.92-3.88-95.47-1.72",
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeDasharray: "4.06554, 4.06554",
      transformOrigin: "141.185px 170.849px"
    },
    id: "elms597ozo6ql",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.41,170.54l-2,.16",
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "90.41px 170.62px"
    },
    id: "elazsdsp4tc17",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.88,243.22l-2.39-25.5a5.72,5.72,0,0,1,5.37-6.25c14.7-.85,52.72-2.85,67.31-1.68,7,.56,14.61,2.81,18,9.51,2.82,5.52,3.24,13.8-1.49,18.34-7.2,6.9-20.86,6.37-30.14,6.7C126.26,245,86.89,243.37,86.88,243.22Z",
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "130.868px 226.964px"
    },
    id: "elju3uzw8509",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.28,227.63c0-.71,3.64,14.65-9.66,19.72s-74.85,3.47-74.85,3.47v-7.2s43.54.92,50.79.72S176.5,246.55,177.28,227.63Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "135.253px 239.333px"
    },
    id: "elyn416icl2b",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.49,313.43s10.88,6.37,14.95,18.34",
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "171.965px 322.6px"
    },
    id: "elu3styhh74jj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.79,215.3s53.36-2.51,66.94-2.06,20.23,3.44,21.58,11.95S166.43,239,159.87,240s-73,1.29-73,1.29",
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeDasharray: "4, 4",
      transformOrigin: "129.123px 227.238px"
    },
    id: "elazxa7xpx3ej",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.46,318.39S113.2,289.7,98,284.05c0,0-3-19.58,3.48-20.66s24.78-13.14,20-28.19-19.13,7.55-28.69,8.42-20,13.5-19.57,24.36-10,31.29-7.39,43,18.7,32.6,20,43.47",
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "93.8384px 292.247px"
    },
    id: "elqmtpyzcdnjb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.45,239.21s11.45,2.08,17.67-5.19-.94-7.73-.94-7.73Z",
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "111.555px 232.888px"
    },
    id: "elj9wsekewix",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81,255.41a12.58,12.58,0,0,1,5.88,1.93",
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "83.94px 256.375px"
    },
    id: "elfsuvkh0yf0d",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.65,259.57a11.06,11.06,0,0,1,5.72,2.26",
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "83.51px 260.7px"
    },
    id: "elojjc5ra9ur",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.56,298s49-2.53,61.9-1.79",
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "142.51px 297.037px"
    },
    id: "ellviddoykb2n",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.53,292.47s12.33-1,20,0",
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "171.53px 292.248px"
    },
    id: "elnj6xa24ei39",
    className: "animable"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 192.77,
    y1: 296.07,
    x2: 212.72,
    y2: 296.07,
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "202.745px 296.07px"
    },
    id: "elnfzg73cz4fa",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.84,186.49s87.63-7.83,122.84-3.36c0,0,9.5,17.47,7.43,107A1123.46,1123.46,0,0,1,215.83,299",
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeDasharray: "4, 4",
      transformOrigin: "270.123px 240.376px"
    },
    id: "elklwjdknv6ir",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Card--inject-34",
    className: "animable",
    style: {
      transformOrigin: "338.973px 284.945px"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "elm86akkbkaaf"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1,
      transformOrigin: "331.322px 287.128px"
    },
    className: "animable"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M442.06,310.39c-2.49-10.59-6.14-14.57-9.8-17.63,0,0-.08-6-4.77-9.42a31.8,31.8,0,0,0-4-3c-4.4-3.3-9.25-7-9.25-7-2.28-6.6-5.37-14.59-8.71-22.45l.17,1.79c-3.42-8.35-6.77-16.66-7.71-19.42l0-.06c1,2.66,2,5.23,3.1,7.6l-12.52-44.25c-.3-1.78-.61-3.53-.92-5.22-.6-5-2.23-14.42-6.16-15.09a3.27,3.27,0,0,0-.44,0s-4.63-2-4.63,6.21c-5.51,1.84-7.64,6-8.17,10.89a14.62,14.62,0,0,0-.1,4.7c.1,1.81.31,3.66.59,5.5L351,180.22,349.29,178l-21.88-28.8L298,110.4a13.77,13.77,0,0,0-19.3-2.63L242.19,135.5l-14.25,10.82c-10.93,5.69-8.08,16.93-5.05,20.92l63.67,83.81a6.63,6.63,0,0,0-1-.05s-1.82-4.29-6.32-3.61a5.21,5.21,0,0,0-2.68.89,4.81,4.81,0,0,0-1.79,1.63,14.22,14.22,0,0,0-1.34,1.92c-2.29,3.92-.17,13.51,3.14,25.22.21.76.42,1.49.62,2.17l0,.11.85,2.93c3.24,11.24,9.3,33.31,10.42,44.13.08,1,.13,2.07.15,3.07.07,12.46-5.46,33.32-3.08,41.94.31,1.13.63,2.21.95,3.28,1.77,5.76,3.35,11.21,6.13,16.62,3.38,6.6,7.41,12.93,11.18,19.32q10.38,17.61,21.48,34.8c3.41,5.26,7.4,10.06,11.26,15,1.77,2.27,5.63,5.68,6.3,8.59,0,0,34.23,2.83,53.39-9.34l-1.8-27.24,12.85-73.85c3.67-5.57,15-16.45,17.26-19.89,1.17-1.71,2.31-3.41,3.42-5.07,8.45-7.89,12.68-14,14.54-21.11C442.53,312.53,442.4,311.72,442.06,310.39ZM322.19,324.84v0Zm1.37,1.68-.17-.32a40.46,40.46,0,0,0,11,3.2C330.4,328.94,325.89,328.3,323.56,326.52ZM338,329.83h0l1.84.13A13.78,13.78,0,0,1,338,329.83Zm-14.8-4.06-2.3-4.56c-3.2-9.18-10.43-30.82-10.46-30.91h0A125,125,0,0,0,304.78,272a10.89,10.89,0,0,0,10.21-1.6l17.5-13.29c1.81,1.09,3.66,2.07,5.47,2.93l16.39,12.81-13,53.43Zm66.34-123.06h0c1.36,6.38,3.51,15.56,6.36,24.45A160.3,160.3,0,0,1,389.52,202.71Z",
    id: "ela1hsv6fwk2m",
    className: "animable",
    style: {
      transformOrigin: "331.322px 287.128px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.25,459.45l.1.48S315.32,459.75,315.25,459.45Z",
    id: "elwewgxy5tmr",
    className: "animable",
    style: {
      transformOrigin: "315.3px 459.69px"
    }
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M376,204.67c1-.66,15.66-8.64,23,15.29s15.95,64.65,15.95,64.65L397.51,288s-16.16-8.6-30.64-30.14c0,0-20.3-5.26-29.14-17.76-8-11.36,16.68-53.07,16.68-53.07Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "375.542px 237.515px"
    },
    id: "elp9ozqnnsggi",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.73,234.45c4.32,6.48,12.5,20.11,23.54,24.41",
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "381.5px 246.655px"
    },
    id: "elylks0uf701o",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.51,241.42c2,.81,7,3.69,9.36,3.8,0,0,10.19,20.17,27,26.72",
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "375.69px 256.68px"
    },
    id: "ellf88wfhg9wo",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.16,248.85c6.25,5.23,13.7,8.8,18.71,9,0,0,10.19,20.17,27,26.72",
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "371.015px 266.71px"
    },
    id: "el0v6f20b2io3g",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elhdcyvwwngj"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 267.27,
    y: 108.53,
    width: 91.28,
    height: 148.81,
    rx: 10.92,
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "312.91px 182.935px",
      transform: "rotate(-37.22deg)"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M384,219l-50.74,38.55a13.75,13.75,0,0,1-19.3-2.64l-73.35-96.56a13.48,13.48,0,0,1-2.46-5.28,13.71,13.71,0,0,1,5.09-14l14.26-10.82L294,100.51a13.77,13.77,0,0,1,19.3,2.64l29.43,38.74,21.88,28.8,22,29A13.77,13.77,0,0,1,384,219Z",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "313.617px 179.034px"
    },
    id: "ely2tbs5uhr7",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el0by1rqn50yls"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M342.69,141.89l-85.22-13.65L294,100.51a13.77,13.77,0,0,1,19.3,2.64Z",
    style: {
      opacity: 0.1,
      transformOrigin: "300.08px 119.797px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elpfj2pjv0nd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M384,219l-50.74,38.55a13.75,13.75,0,0,1-19.3-2.64l-73.35-96.56a13.48,13.48,0,0,1-2.46-5.28L366.29,173l20.32,26.75A13.77,13.77,0,0,1,384,219Z",
    style: {
      opacity: 0.1,
      transformOrigin: "313.776px 206.717px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elzht4v9ti96a"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 294.91,
    y: 111.05,
    width: 19.41,
    height: 26.09,
    rx: 4.08,
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "304.615px 124.095px",
      transform: "rotate(-37.22deg)"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("line", {
    x1: 296.91,
    y1: 113.56,
    x2: 312.38,
    y2: 134.58,
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "304.645px 124.07px"
    },
    id: "el9wo9ddzefhq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 296.91,
    y1: 130.01,
    x2: 312.38,
    y2: 118.28,
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "304.645px 124.145px"
    },
    id: "eljkoiov8y8h",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "326.87 251.26 324.23 253.2 292.02 210.8 294.64 208.82 326.87 251.26",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "309.445px 231.01px"
    },
    id: "eldem45y2rfeg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "331.34 247.95 328.7 249.91 296.45 207.44 299.05 205.46 331.34 247.95",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "313.895px 227.685px"
    },
    id: "elm2gncf4ciop",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "335.8 244.66 333.17 246.6 300.87 204.09 303.48 202.1 335.8 244.66",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "318.335px 224.35px"
    },
    id: "elu5byvmce8w7",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "340.27 241.35 337.63 243.29 305.76 201.34 308.36 199.35 340.27 241.35",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "323.015px 221.32px"
    },
    id: "eljbmlrsnmxqc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "345.09 237.79 342.45 239.74 310.53 197.72 313.14 195.73 345.09 237.79",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "327.81px 217.735px"
    },
    id: "el83w95i08fa2",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "345.09 188.35 342.45 190.29 310.53 148.27 313.14 146.29 345.09 188.35",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "327.81px 168.29px"
    },
    id: "elzmyglg25p19",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elbwim36h1pte"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 315.94,
    y: 101.01,
    width: 5.13,
    height: 148.7,
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "318.505px 175.36px",
      transform: "rotate(-37.22deg)"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M384,219l-50.74,38.55a13.75,13.75,0,0,1-19.3-2.64l-73.35-96.56a13.48,13.48,0,0,1-2.46-5.28,13.71,13.71,0,0,1,5.09-14l14.26-10.82L294,100.51a13.77,13.77,0,0,1,19.3,2.64l29.43,38.74,21.88,28.8,22,29A13.77,13.77,0,0,1,384,219Z",
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "313.617px 179.034px"
    },
    id: "elbsspqfhngkb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.87,469s59.06,21,76.93-24.74c0,0-27.95-34-12.69-61.78,9.6-17.5,36.15-56.13,36.15-56.13s11.09-10.53,14.54-21.11c0,0-1.9-11.79-10.26-19.77,0,0-.09-6-4.78-9.42s-13.29-10-13.29-10S415.33,232.13,413.23,226s-6.32-17.72-8.43-30.52-4.06-26.58-8.54-26.54c0,0-4.62-2-4.62,6.21,0,0-9.7,5-8.27,15.58s2.75,16.05,2.37,22,1.53,26.61,6.31,33.09c0,0,1.6,29,4,36.55.08.23.15.44.22.63,2.52,6.39-22.66,31-36.29,37.66,0,0-1.43,2.66-6.72,1.93s-14.24-1.07-15.78-5S325.69,283,325.69,283s-8.29-39.3-24.85-39.29c0,0-2.51-6-9-2.72s-2.24,21.16.63,30.94,10.14,35.49,11.32,47.32-5.52,35.53-3,44.85,5.32,15.61,13.36,30.87S340,455.73,342.87,469Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "373.114px 321.269px"
    },
    id: "elaqdbfcuha65",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.87,469s-12.64-47.58-31.22-78.35S304,349,304,323.39s-20.87-69.21-15.24-78.82,13.31-1.92,16.52,7.05S304,265.72,295,266.36",
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "315.333px 354.566px"
    },
    id: "elw7ocizufda9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.84,243.75s10.79-.66,17.42,16.59,17.25,61,28.31,74.31",
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "323.705px 289.198px"
    },
    id: "el5hk639ecv7m",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.84,318.49c.06.14,15.45,8.72,39.33,1.2",
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "357.505px 320.632px"
    },
    id: "elz3x9k6726v",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.89,294.38a10.81,10.81,0,0,1,10.1-3.83",
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "307.94px 292.395px"
    },
    id: "elxamcap4737",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.94,299.81a8.61,8.61,0,0,1,8.69-2.83",
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "309.285px 298.267px"
    },
    id: "elpormoq5yxre",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.64,175.12c-15.7,5.23-4,28.94-5.9,37.59s3,25.21,6.77,34.19c0,10.53,3.75,36.08,3.75,36.08-2.32,8.13-21.68,32.09-40.49,39.59",
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "376.015px 248.845px"
    },
    id: "el2mpowhqclq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.16,187.06s-1.17-18.15-6.9-18.15-5.38,12.23-3,21.31S404.9,198,403.16,187.06Z",
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "397.506px 182.575px"
    },
    id: "elricqic232ho",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.16,187.06s4.88,28.53,13.15,46.45",
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "409.735px 210.285px"
    },
    id: "el5elwghegn3t",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.06,300.33c4-6.48,5.77-12.61,7.25-20.41-.37-4.89-6-20.85-12.54-36.31",
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "427.04px 271.97px"
    },
    id: "elz6f4dxptm0s",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430,267.56c6.49,4.88,17.78,8.63,16.48,17.05a70.79,70.79,0,0,1-8.7,23.89",
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "438.292px 288.03px"
    },
    id: "elh541s3b2rpn",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.24,446.39S398.63,415,403.16,393.32c3.33-15.95,24.74-43.84,40.1-66.94,8.46-7.89,12.69-14,14.54-21.11-2.71-13.35-7.11-17.24-11.34-20.66",
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "430.18px 365.5px"
    },
    id: "elkman1qczg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.27,272.74a19.11,19.11,0,0,0-15.07,2.05",
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "419.735px 273.408px"
    },
    id: "el27z7hg45x0l",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426,278.11a14.25,14.25,0,0,0-8.94,1.57",
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "421.53px 278.815px"
    },
    id: "el5sseqf4ujg",
    className: "animable"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "active",
    height: "200%"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    in: "SourceAlpha",
    result: "DILATED",
    operator: "dilate",
    radius: 2
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#32DFEC",
    floodOpacity: 1,
    result: "PINK"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "PINK",
    in2: "DILATED",
    operator: "in",
    result: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "hover",
    height: "200%"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    in: "SourceAlpha",
    result: "DILATED",
    operator: "dilate",
    radius: 2
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#ff0000",
    floodOpacity: 0.5,
    result: "PINK"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "PINK",
    in2: "DILATED",
    operator: "in",
    result: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0   0   0   0   0                0   1   0   0   0                0   0   0   0   0                0   0   0   1   0 "
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWallet);
export default __webpack_public_path__ + "static/media/Wallet.c309b67d9bbce487ed3a8343716a88ac.svg";
export { ForwardRef as ReactComponent };